import styled from "@emotion/styled"
import { PButton, PText } from "@porsche-design-system/components-react"
import { useContext } from "react"
import { FormattedMessage } from "react-intl"
import { ButtonGroup } from "src/components"
import { Modal } from "src/context/modal/Modal"
import { ModalContext } from "src/context/modal/ModalContext"
import type { ModalProps } from "src/context/modal/ModalProvider"
import { newsEditorMessages as messages } from "./newsEditor.messages"

interface NewsTransitionModalProps {
	confirmLabel: string
	heading: string
	message: string
	onConfirm: () => void
}

export const NewsTransitionModal = ({ id, modalProps }: ModalProps<NewsTransitionModalProps>) => {
	const { hideModal } = useContext(ModalContext)

	const onCancel = () => hideModal(id)

	const onConfirm = () => {
		modalProps.onConfirm()
		hideModal(id)
	}

	return (
		<Modal id={id} heading={modalProps.heading} disableBackdropClick>
			<ModalContent>
				<PText>{modalProps.message}</PText>
				<ButtonGroup>
					<PButton data-testid="news-transition-modal-confirm-button" onClick={onConfirm}>
						{modalProps.confirmLabel}
					</PButton>
					<PButton
						data-testid="news-transition-modal-cancel-button"
						type="button"
						variant="secondary"
						onClick={onCancel}
					>
						<FormattedMessage {...messages.modalCancel} />
					</PButton>
				</ButtonGroup>
			</ModalContent>
		</Modal>
	)
}

const ModalContent = styled.div`
	max-width: 40rem;
`
